/**
 *  Filename ....: existing-members.component.ts
 *  Created by ..: ianday
 *  on Date .....: 3/7/24
 **/
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DwUtils} from "../../../../../components/utils/dw-utils";
import {MatTableDataSource} from "@angular/material/table";

@Component({
    selector: 'app-existing-members',
    templateUrl: './existing-members.component.html',
    styleUrls: ['./existing-members.component.css']
})

export class ExistingMembersComponent implements OnInit {

    public membersList: any;
    public strErr: string = '';
    public submitEnabled: boolean= false;
    public dataSource: MatTableDataSource<any>;
    public selectedRecord: any;

    public Idx: number = -1;
    public displayedColumns = ['id','memberName', 'gender', 'dateOfBirth'];

    constructor() {

    }

    @Output() submitClicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() cancelClicked: EventEmitter<any> = new EventEmitter<any>();

    ngOnInit() {

    }
    public onshowHandler(): void {
        this.dataSource = new MatTableDataSource<any>()
        this.dataSource.data = this.membersList;
    }

    public returnFullName(e: any): string {
        return DwUtils.returnFullName(e.firstName, e.middleName, e.lastName);
    }
    public truncateDOB (dob: string): string {

        return DwUtils.formatDateFromString(dob);
    }
    public tableKeyDown(event: any): void {
        const len: number = this.dataSource.filteredData.length;
        if (event.key === 'ArrowDown') {
            if (this.Idx < (len - 1)) {
                this.selectedRecord = this.dataSource.filteredData[++this.Idx];
            }
        } else if (event.key === 'ArrowUp') {
            if (this.Idx > 0) {
                this.selectedRecord = this.dataSource.filteredData[--this.Idx];
            }
        }
    }
    public onRowClicked(selected:any): void {
        this.selectedRecord = selected;
        this.submitEnabled = true;
        this.selectRow();
    }
    public selectRow(): void {
        this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
    }
    public onRowDoubleClicked(row: any): void {
        this.submitRecord();
    }
    public submitRecord(): void {
        this.submitClicked.emit(this.selectedRecord);
    }
    public cancelSubmitRecord(): void {
        this.cancelClicked.emit();
    }
}


